import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

/**
 * Echtzeit-Synchronisation (NFR-07): Server-Sent Events des Backends aktualisieren betroffene Abfragen,
 * z. B. wenn der Timer in einem anderen Tab, auf dem Handy oder am Kiosk gestartet wird.
 */
export function useRealtime(enabled: boolean) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!enabled || typeof EventSource === 'undefined') return;
    const source = new EventSource('/api/v1/realtime/stream', { withCredentials: true });
    const onEntries = (event: MessageEvent<string>) => {
      let workspaceId: string | undefined;
      try {
        workspaceId = (JSON.parse(event.data) as { workspaceId?: string }).workspaceId;
      } catch {
        workspaceId = undefined;
      }
      const prefix = workspaceId ? ['workspace', workspaceId] : ['workspace'];
      void qc.invalidateQueries({ queryKey: [...prefix, 'time-entries'] });
      void qc.invalidateQueries({ queryKey: [...prefix, 'reports'] });
      void qc.invalidateQueries({ queryKey: [...prefix, 'dashboard'] });
    };
    const onNotifications = () => void qc.invalidateQueries({ queryKey: ['notifications'] });
    source.addEventListener('time-entries', onEntries as EventListener);
    source.addEventListener('notifications', onNotifications);
    return () => source.close();
  }, [enabled, qc]);
}
